export const environment = {
  production: true,
  BASE_DOMAIN:'https://ems.apollosupplychain.com/',
  New_BASE_DOMAIN:'https://ems.apollosupplychain.com/',
  COOKIE_DOMAIN: 'localhost',
  ORDER_URL: 'https://ems.apollosupplychain.com/',
  WebsocketUrl: 'wss://ems.apollosupplychain.com/websocket-service/ws/notifications'
};
